/**
 * Hero principal de la marca.
 *
 * Cumple una función 100% comercial:
 * presentar la propuesta de valor y empujar al usuario hacia conversión.
 */
import React from "react";
import "./HeroSection.scss";

const HeroSection = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <p className="hero-kicker">Nutrición, entrenamiento y hábitos</p>
        <h1>
          Descubre el poder de tu <span>magia interna</span>
        </h1>
        <p className="hero-copy">
          Un acompañamiento integral para reconectar con tu cuerpo, construir
          rutinas sostenibles y avanzar con claridad todos los días.
        </p>
        <div className="hero-actions">
          <a className="cta-button cta-button--primary" href="#membresias">
            Ver membresías
          </a>
          <a className="cta-button cta-button--secondary" href="#instalar">
            Instala la app
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
